export default __webpack_public_path__ + "static/media/grf.2a3d08de.png";